export const NAMESPACE = 'layout'